import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { downloadFile } from '../../../../../services/apiClient';
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisVertical,
  faDownload,
  faEye,
  faFilePdf,
  faFileExcel
} from '@fortawesome/free-solid-svg-icons';
import '../QueueFull/cabinet-zdo-requests.css';
import './reports.css';

const ReportsList = ({kg_id}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);

  // Данные отчетов
  const reportsData = [
    {
      id: 1,
      reportName: 'Звіт за формою к85 на початок року',
      description: 'Звіт про фінансову діяльність на початок року',
      status: 'активний',
      fileType: 'xlsx',
      fileName: 'zvit_k85_pochatok_roku_2024.xlsx',
      fileSize: '2.1 МБ',
      createdAt: '15.01.2024',
      updatedAt: '15.01.2024'
    },
    {
      id: 2,
      reportName: 'Звіт за формою к85 на поточну дату',
      description: 'Поточний фінансовий звіт',
      status: 'активний',
      fileType: 'xlsx',
      fileName: 'zvit_k85_potochna_data_2024.xlsx',
      fileSize: '3.5 МБ',
      createdAt: '25.09.2024',
      updatedAt: '25.09.2024'
    },
    {
      id: 3,
      reportName: 'Звіт щодо нарахувань по харчуванню',
      description: 'Детальний звіт по нарахуванням за харчування',
      status: 'активний',
      fileType: 'pdf',
      fileName: 'zvit_narahuvannya_harchuvannya_2024.pdf',
      fileSize: '1.8 МБ',
      createdAt: '20.09.2024',
      updatedAt: '20.09.2024'
    },
    {
      id: 4,
      reportName: 'Квітанції на оплату для батьків',
      description: 'Квітанції для оплати за навчання та харчування',
      status: 'активний',
      fileType: 'pdf',
      fileName: 'kvitantsiyi_oplata_batkiv_2024.pdf',
      fileSize: '4.2 МБ',
      createdAt: '10.09.2024',
      updatedAt: '10.09.2024'
    },
    {
      id: 5,
      reportName: 'Звіт по відвідуваності',
      description: 'Щомісячний звіт про відвідуваність дітей',
      status: 'архівний',
      fileType: 'xlsx',
      fileName: 'zvit_vidviduvannist_08_2024.xlsx',
      fileSize: '2.3 МБ',
      createdAt: '01.09.2024',
      updatedAt: '01.09.2024'
    },
    {
      id: 6,
      reportName: 'Фінансовий звіт за півріччя',
      description: 'Підсумковий фінансовий звіт за перше півріччя',
      status: 'активний',
      fileType: 'pdf',
      fileName: 'fin_zvit_pivrichcha_2024.pdf',
      fileSize: '5.1 МБ',
      createdAt: '01.07.2024',
      updatedAt: '01.07.2024'
    }
  ];

  const columns = [
    {
      key: 'id',
      label: '№',
      sortable: true,
      width: '5%'
    },
    {
      key: 'reportName',
      label: 'Звітний документ',
      sortable: true,
      width: '30%'
    },
    {
      key: 'description',
      label: 'Опис',
      sortable: true,
      width: '35%'
    },
    {
      key: 'status',
      label: 'Статус',
      sortable: true,
      width: '10%'
    },
    {
      key: 'actions',
      label: 'Дії',
      sortable: false,
      width: '20%'
    }
  ];

  // Функция сортировки
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Сортированные данные
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return reportsData;
    
    return [...reportsData].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [reportsData, sortConfig]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleMenuToggle = (index, e) => {
    e.stopPropagation();
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleMenuClose = () => {
    setActiveMenuIndex(null);
  };

  const handleActionSelect = (actionId, report) => {
    if (actionId === 'download') {
      // Логика загрузки файла

      if(kg_id && report.id == 1) downloadFile(`get_k85?kg_id=${kg_id}`);
      
    } else if (actionId === 'view') {
      // Логика просмотра файла
      simulateFileView(report);
    }
    setActiveMenuIndex(null);
  };

  const simulateFileDownload = (report) => {

    const link = document.createElement('a');
    link.href = `#${report.fileName}`;
    link.download = report.fileName;
    link.click();
    
  };

  const simulateFileView = (report) => {
    
    console.log(`Перегляд файлу: ${report.fileName}`);
    window.open(`#preview/${report.fileName}`, '_blank');
  };

  const getFileIcon = (fileType) => {
    return fileType === 'pdf' ? faFilePdf : faFileExcel;
  };

  const getFileColor = (fileType) => {
    return fileType === 'pdf' ? '#f40f02' : '#217346';
  };

  const getStatusBadge = (status) => {
    const statusClass = status === 'активний' ? 'status-active' : 'status-archived';
    return (
      <span className={`status-badge ${statusClass}`}>
        {status}
      </span>
    );
  };

  const ActionsMenu = ({ onActionSelect, onClose, report }) => {
    const actions = [
      {
        id: 'view',
        label: 'Переглянути',
        icon: faEye
      },
      {
        id: 'download',
        label: 'Завантажити',
        icon: faDownload
      }
    ];

    return (
      <div className="actions-dropdown">
        {actions.map((action) => (
          <button
            key={action.id}
            className="dropdown-item d-flex align-items-center gap-2 p-2"
            onClick={() => onActionSelect(action.id, report)}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
              width: '100%',
              textAlign: 'left',
              fontSize: '14px',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <FontAwesomeIcon icon={action.icon} style={{ width: '16px', color: '#6c757d' }} />
            <span style={{ color: '#212529' }}>{action.label}</span>
          </button>
        ))}
        
        <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
          <button
            className="btn btn-sm btn-outline-secondary w-100"
            onClick={onClose}
            style={{ fontSize: '12px' }}
          >
            Скасувати
          </button>
        </div>
      </div>
    );
  };

  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          {/* Заголовок */}
          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Звітні документи</span>
            </div>
            <div className="queuetable-switch-wrap">
              <div className="text-muted small">
                Всього {reportsData.length} звітів
              </div>
            </div>
          </div>

          {/* Таблица */}
          <div className="card queuetable-table-card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table queuetable-table align-middle mb-0">
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th 
                          key={column.key}
                          style={{ width: column.width }}
                          onClick={() => column.sortable && handleSort(column.key)}
                        >
                          <div className="d-flex align-items-center">
                            {column.label}
                            {column.sortable && (
                              <FontAwesomeIcon 
                                icon={getSortIcon(column.key)} 
                                className="ms-1" 
                                style={{ fontSize: '12px' }}
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.map((report, index) => (
                      <tr key={report.id}>
                        <td>{report.id}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon 
                              icon={getFileIcon(report.fileType)} 
                              className="me-2"
                              style={{ 
                                color: getFileColor(report.fileType),
                                fontSize: '1.2em'
                              }}
                            />
                            <div>
                              <div className="fw-medium">{report.reportName}</div>
                              <small className="text-muted">
                                {report.fileType.toUpperCase()} • {report.fileSize}
                              </small>
                            </div>
                          </div>
                        </td>
                        <td>{report.description}</td>
                        <td>{getStatusBadge(report.status)}</td>
                        <td className="queuetable-actions text-end">
                          <div className="actions-menu-container" style={{ position: 'relative', display: 'inline-block' }}>
                            <button
                              className="btn btn-sm btn-link text-decoration-none p-0"
                              onClick={(e) => handleMenuToggle(index, e)}
                              style={{ color: '#0d6efd' }}
                            >
                              <FontAwesomeIcon icon={faEllipsisVertical} />
                            </button>
                            
                            {activeMenuIndex === index && (
                              <ActionsMenu 
                                onActionSelect={handleActionSelect}
                                onClose={handleMenuClose}
                                report={report}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Пагинация */}
              <div className="d-flex align-items-center mt-4 queuetable-pagination-wrapper">
                <div className="queuetable-pagination-info">
                  Показано {sortedData.length} з {reportsData.length} звітів
                </div>
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className="page-item disabled">
                      <button className="page-link" aria-label="Previous">
                        <span aria-hidden="true">&lt;</span>
                      </button>
                    </li>
                    <li className="page-item active">
                      <button className="page-link">1</button>
                    </li>
                    <li className="page-item">
                      <button className="page-link">2</button>
                    </li>
                    <li className="page-item">
                      <button className="page-link" aria-label="Next">
                        <span aria-hidden="true">&gt;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReportsList;